import React, { useState } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import { postTransferCertificate } from "../Service/Api";
import NKRFooter from "../Component/NKRFooter";
import NKRHeader from "../Component/NKRHeader";
const Tc = () => {
  const [admission, setAdmission] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleAdmissionNoChange = (event) => {
    setAdmission(event.target.value);
    setError(""); // Clear error on user input
  };

  const handleFullNameChange = (event) => {
    setName(event.target.value);
    setError(""); // Clear error on user input
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !admission) {
      setError("Please fill in all fields");
      return;
    }

    try {
      const response = await postTransferCertificate(name, admission);
      if (response) {
        console.log(response.data);
        // Potentially navigate or show success message
        fetch(
          `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${response.data}`,
        )
          .then((response) => response.blob()) // Assuming the data is in a blob format; adjust if different
          .then((blob) => {
            // Create a link element, use it to download the blob
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "tc.jpg"; // Set the file name and extension
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            // alert('Your download has started.');  // Optional: Notify the user
          })
          .catch(() => alert("Failed to download data.")); // Error handling
      }
    } catch (error) {
      console.error("Failed to post data", error);
      setError("Failed to process your request. Please try again later.");
    }
  };

  return (
    <>
      <NKRHeader />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Transfer Certificate</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/Nekhpur/Home">Home</Link>
            </li>
            <li>|</li>
            <li>Transfer Certificate</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="formfil">
                <form onSubmit={handleSubmit} className="tc">
                  <div className="text_box_sec form-group">
                    <label htmlFor="admission">Admission No.</label>
                    <input
                      type="text"
                      placeholder="Admission Number"
                      id="admission"
                      className="form-control"
                      value={admission}
                      onChange={handleAdmissionNoChange}
                    />
                  </div>
                  <div className="text_box_sec form-group mt-4">
                    <label htmlFor="name">Student Full Name</label>
                    <input
                      type="text"
                      placeholder="Student Name"
                      id="name"
                      className="form-control"
                      value={name}
                      onChange={handleFullNameChange}
                    />
                  </div>
                  <div className="text_box_sec mt-4">
                    <input
                      type="submit"
                      name="btnshwtcdetails"
                      value="View Details"
                      id="btnshwtcdetails"
                      className="btn btn-danger viewdetailsbtn"
                    />
                  </div>
                  {error && <p className="error">{error}</p>}
                </form>
              </div>
            </div>
            <div className="col-lg-6">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/nekhpurpdf/TC-sample.pdf#toolbar=0"
                width="100%"
                height="500"
                title="Transfer Certificate Sample"
                rel="noreferrer"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <NKRFooter />
    </>
  );
};

export default Tc;
